import React from 'react';
import { Paragraph } from '@uncinc/react-drupal-core';
import {
  Container,
} from '../../../components';

const CTAWrapper = ({ entity }) => {
  const id = entity.getIn(['field_cta', 0, 'target_id']);
  const paragraphKey = `paragraph:${id}`;
  if (!id) {
    return null;
  }

  return (
    <Container className="Paragraph">
      <div key={paragraphKey} id={paragraphKey}>
        <Paragraph
          id={id}
          entity={entity.getIn(['field_cta', 0, 'entity'])}
          display={entity.getIn(['field_display', 0, 'value'])}
        />
      </div>
    </Container>
  );
};

export default CTAWrapper;

